export default __webpack_public_path__ + "static/media/wstepne_osadniki.d7e33d6e.png";